export default __webpack_public_path__ + "HIV检测.jpg";